module.exports = __webpack_public_path__ + "img/curas3.612fc3ab.jpg";